const updateInstrumentName = (instrumentNameField, decodedInstrument, instrumentId) => {
    if (decodedInstrument?.instrumentId !== instrumentId) {
        return;
    }

    instrumentNameField.text(decodedInstrument?.instrumentName);
};

(($) => {
    const instrumentDetails = localStorage.getItem('instrumentDetail');
    const decodedInstrument = JSON.parse(instrumentDetails);

    const instrumentIdField = $('#instrumentId');
    const instrumentNameField = $('#instrumentName');

    // id fields do not exist on ss template
    if (!instrumentNameField || !instrumentIdField) {
        return;
    }

    // splits and removes the last value from the array, followed by re-joining the instrumentId
    const instrumentId = instrumentIdField.text()?.split('.').slice(0, -1).join('-');

    // no values exist in array after splitting
    if (instrumentId.length < 1) {
        return;
    }

    // if instrument is not a new Hobson Wealth Fund early return here
    if (instrumentId === 'HWNZFIF' || instrumentId === 'HWNZEF' || instrumentId === 'HWIGF') {
        const errorHeaderField = $('#errorHeader');
        const errorSubheaderField = $('#errorSubheader');

        // error header fields do not exist on ss template
        if (!errorHeaderField || !errorSubheaderField) {
            updateInstrumentName(instrumentNameField, decodedInstrument, instrumentId);
            return;
        }

        // set custom error messages for Hobson Wealth Funds
        errorHeaderField.text('More detailed information on the underlying investments is not currently available via the website.');
        errorSubheaderField.text('Please contact your Investment Adviser if you would like more information.');

        updateInstrumentName(instrumentNameField, decodedInstrument, instrumentId);
        return;
    }

    updateInstrumentName(instrumentNameField, decodedInstrument, instrumentId);
})(jQuery);
